// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionC2_comp__wcV0M"};